import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    getAllConditions,
    getProcedure, getProcedureHistoryByConceptAPI, getProcedures, postProcedure, putProcedure
} from '../../../api/medicalRecord';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';

export const useProcedures = (medicalRecordNumber, entryId, actual) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        medicalRecordNumber: medicalRecordNumber ? medicalRecordNumber : 0,
        entryId: entryId ? entryId : 0,
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        },
        actual: actual ?? false,
        filters: { searchTerm: '' }
    });
    const [reload, setReload] = useState(false);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setReload(false);
                setIsLoading(true);
                const paginatedItems = await getProcedures(query);

                if (isSubscribed) {
                    setTotalSize(paginatedItems.data.count);
                    setData(paginatedItems.data.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setTotalSize(0);
                setData([]);
            }
        }
        if (medicalRecordNumber || entryId)
            fetchData();

        return () => isSubscribed = false;
    }, [query, reload]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        var newQuery = JSON.parse(JSON.stringify(query));

        switch (type) {
            case 'pagination': {
                newQuery.pagination.page = page;
                newQuery.pagination.sizePerPage = sizePerPage;
                setQuery(newQuery);
                break;
            }
            case 'sort': {
                newQuery.sort.sortField = sortField;
                newQuery.sort.sortOrder = sortOrder;
                setQuery(newQuery);
                break;
            }
            default: break;
        }
    }

    const setSearchTerm = (searchTerm) => {
        setQuery(prev => ({
            ...prev,
            filters: { ...prev.filters, searchTerm },
            pagination: { ...prev.pagination, page: 1 }
        }));
    }

    return [data, query, totalSize, isLoading, handleTableChange, setReload, setSearchTerm];
}

export const useProcedure = (medicalRecordNumber, entryId, id) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [masterData, setMasterData] = useState(null);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                const res = await getProcedure(entryId, id);

                if (isSubscribed) {
                    //console.log(res.data)
                    setData(res.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setData(null);
            }
        }

        const getMasterData = async () => {
            try {
                const query = {
                    medicalRecordNumber: medicalRecordNumber,
                    pagination: {
                        page: 1,
                        sizePerPage: 100,
                        totalSize: 0
                    },
                    filters: {}
                };

                const paginatedItems = await getAllConditions(query);

                var resEvents = paginatedItems.data;
                const abiertas = resEvents.data.filter(e => e.toYear == null);
                const cerradas = resEvents.data.filter(e => e.toYear != null);
                [...abiertas, ...cerradas].forEach(event => { event.reasonId = event.id; });

                const groups = [
                    { label: t('medicalRecords.indicationReason.others'),     options: [{ id: 0, adverseEffect: t('medicalRecords.indicationReason.prophylaxis') }] },
                    { label: t('medicalRecords.indicationReason.conditions'), options: abiertas },
                    { label: t('medicalRecords.indicationReason.closed'),     options: cerradas },
                ];
                setMasterData(groups);
            }
            catch (error) {
                console.log(error)
                setMasterData([]);
            }

            setIsLoading(false);
        }

        if (entryId || medicalRecordNumber)
            getMasterData();

        if (id)
            fetchData();

        return () => isSubscribed = false;
    }, [medicalRecordNumber, entryId, id]);

    const create = (entryId, data) => {
        return postProcedure(entryId, data);
    }

    const update = (entryId, id, data) => {
        data.reason ? data.reasonId = data.reason.id : data.reasonId = 0
        return putProcedure(entryId, id, data);
    }

    return [data, masterData, isLoading, create, update];
}

export const useProcedureHistoryByConcept = () => {

    const fetchData = (medicalRecordNumber, conceptId) => {
        try {
            return getProcedureHistoryByConceptAPI(medicalRecordNumber, conceptId);
        } catch (error) {
            HandleApiError(error);
        }
    }
    return [fetchData];
}